/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tr_7_QInputs */

const en_tut_tr_7_q = /** @type {(inputs: Tut_Tr_7_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I cannot get into a room in the office.`)
};

const id_tut_tr_7_q = /** @type {(inputs: Tut_Tr_7_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saya tidak bisa masuk ke sebuah ruang di kantor.`)
};

/**
* | output |
* | --- |
* | "I cannot get into a room in the office." |
*
* @param {Tut_Tr_7_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tr_7_q = /** @type {((inputs?: Tut_Tr_7_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tr_7_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tr_7_q(inputs)
	return en_tut_tr_7_q(inputs)
});